import { useAuth } from '../context/AuthContext';
import styles from '../css/sidebar.module.scss';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();

  const handleLogout = async () => {
    await logout();
    window.location.replace('/login');
  };

  const handleToggleMobileMenu = () => {
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      sidebar.classList.toggle('active');
    }
  };

  const activeLink = window.location.pathname;

  const links = [
    {
      to: '/',
      label: t('sidebar.links.home'),
      icon: '/assets/images/home.svg',
    },
    {
      to: '/dashboard/users',
      label: t('sidebar.links.users'),
      icon: '/assets/images/users.svg',
    },
    {
      to: '/dashboard/orders',
      label: t('sidebar.links.orders'),
      icon: '/assets/images/orders.svg',
    },
    {
      to: '/dashboard/subscriptions',
      label: t('sidebar.links.subscriptions'),
      icon: '/assets/images/subscriptions.svg',
    },
    {
      to: '/dashboard/logs',
      label: t('sidebar.links.logs'),
      icon: '/assets/images/logs.svg',
    },
    {
      to: '/dashboard/shareandearn',
      label: t('sidebar.links.shareAndEarn'),
      icon: '/assets/images/logs.svg',
    },
    {
      to: '/dashboard/promo-code',
      label: t('sidebar.links.promoCode'),
      icon: '/assets/images/logs.svg',
    },
    {
      to: '/dashboard/partner-program',
      label: t('sidebar.links.partnerProgram'),
      icon: '/assets/images/logs.svg',
    }//,
    // {
    //   to: '/dashboard/esim-purchases',
    //   label: t('sidebar.links.esimPurchases'),
    //   icon: '/assets/images/logs.svg',
    // },
    // {
    //   to: '/dashboard/gift-esims',
    //   label: t('sidebar.links.giftEsim'),
    //   icon: '/assets/images/gift-icon.svg',
    // },
  ];

  return (
    <aside id="sidebar" className={styles.sidebar}>
      <div className={styles.logoContainer}>
        <a href="/">
          <img src="/assets/images/travel-care-logo.svg" alt="Travel Care Logo" className={styles.logo} />
        </a>
        <img src="/assets/images/close-icon.svg" alt="Close icon" onClick={handleToggleMobileMenu} />
      </div>
      <nav className={styles.navbar}>
        {user &&
          (user?.role === 'admin' ? (
            <>
              {links.map((link) => (
                <a key={link.to} href={link.to} className={`${styles.navLink} ${activeLink === link.to ? styles.active : ''}`}>
                  <img src={link.icon} alt={link.label} />
                  <p>{link.label}</p>
                </a>
              ))}
            </>
          ) : (
            user?.role === 'skycop' && (
              <a key={'skycop-promo-code'} href={'/dashboard/promo-code'} className={`${styles.navLink} ${activeLink === '/dashboard/promo-code' ? styles.active : ''}`}>
                <img src={'/assets/images/logs.svg'} alt={'Promo Code'} />
                <p>{t('sidebar.promoCode')}</p>
              </a>
            )
          ))}
        {user ? (
          <div
            className={`${styles.navLink} ${styles.logout}`}
            onClick={() => {
              handleLogout();
            }}
          >
            <img src="/assets/images/logout.svg" alt="logout" />
            <p>{t('sidebar.logout')}</p>
          </div>
        ) : (
          <div
            className={`${styles.navLink} ${styles.login}`}
            onClick={() => {
              window.location.replace('/login');
            }}
          >
            <img src="/assets/images/login.svg" alt="login" />
            <p>{t('sidebar.login')}</p>
          </div>
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;
